import DatePickerField from "../../common/DatePickerField ";
import Input from "../../common/Input";
import MultiAutoCompleteCityPicker from "../../common/MultiAutoCompleteCityPicker";
import SelectForm from "../../common/SelectForm";
import TextEditorNormal from "../../common/textEditor";
import CallToPage from "../CallToPage/CallToPage";
import Spinner from "../spinner/Spinner";

const DifinitionForm = ({
  formik,
  packageNameOptions,
  PackagePublishOptions,
  nextStepFlag,
  PackageRuleValue,
}) => {
  const goNextStep = () => {
    nextStepFlag(true);
  };
  return (
    <>
      <div className="flex w-full md:w-2/3 px-3">
        <Input
          formik={formik}
          name="packageName"
          label="نام تور"
          type="text"
          reqiuerd={true}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <MultiAutoCompleteCityPicker
          formik={formik}
          name="PackageSources"
          label="مبدا تور"
          type="text"
          reqiuerd={true}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <MultiAutoCompleteCityPicker
          formik={formik}
          name="PackageDestinations"
          label="مقصد تور"
          type="text"
          reqiuerd={true}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <SelectForm
          formik={formik}
          name="packageType"
          label="نوع تور"
          options={packageNameOptions}
          reqiuerd={true}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3 text-sm">
        <SelectForm
          formik={formik}
          name="PackagePublishState"
          label="قابلیت رزرو"
          options={PackagePublishOptions}
          reqiuerd={true}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <DatePickerField
          label="تاریخ شروع اعتبار پکیج"
          formik={formik}
          name="PackageStartDate"
          reqiuerd={true}
        />
      </div>
      <div className="flex w-1/2 md:w-1/3 px-3">
        <DatePickerField
          label="تاریخ پایان اعتبار پکیج"
          formik={formik}
          name="PackageFinishDate"
          reqiuerd={true}
        />
      </div>
      <div className="flex w-full mb-4">
        <TextEditorNormal
          label="توضیحات"
          formik={formik}
          name="PackageRule"
          descriptionValue={PackageRuleValue}
        />
      </div>
      <div className="w-full flex justify-between px-4 md:px-0">
        <div className="flex w-1/4 mt-2">
          <CallToPage
            address="tourlist"
            text="انصراف"
            bGColor="bg-red-600"
            hoverBgColor="bg-red-700"
          />
        </div>
        <div className="flex w-3/4 justify-end gap-2 h-12">
          <button
            type="submit"
            disabled={!formik.isValid}
            className="block w-24 mt-2 disabled:bg-slate-400 disabled:text-white disabled:cursor-not-allowed bg-darkGreenKite text-white text-center rounded-md py-2 px-4"
          >
            {formik.isSubmitting ? <Spinner /> : "ذخیره"}
          </button>
          <button
            type="submit"
            onClick={goNextStep}
            disabled={!formik.isValid}
            className="block w-30 mt-2 text-xs md:text-base disabled:bg-slate-400 disabled:text-white disabled:cursor-not-allowed bg-darkGreenKite text-white text-center rounded-md py-2 px-4"
          >
            {formik.isSubmitting ? <Spinner /> : "ذخیره و ادامه"}
          </button>
        </div>
      </div>
    </>
  );
};

export default DifinitionForm;
